<template>
  <NuxtLayout name="404">
    <UiError404 />
  </NuxtLayout>
</template>
